module.exports = __webpack_public_path__ + "static/media/AdditionalDetailsRightHalfCloud.02399328.png";